export const systemLanguages = ['cs', 'en', 'nl'];
